/**
 * Created by cristianofaria on 17/01/2017.
 */
/************************************************************
 ViewController Namespace
 ************************************************************/

window.viewControllerNS = {
/************************************************************
* FIELD PERMISSIONS
 ************************************************************/
    checkFieldPermissions: function(field, callback){
        //Hades.showLoading();

        var params = {
            field_name: $(field).data('permission_field_name')
        };

        //debug.log('viewControllerNS.checkFieldPermissions', params, field);

        if (!viewControllerNS[params.field_name]){
            $.getJSON('/permission/get_field_permission_details', params)
                .done(function (data, status, xhr) {
                    Hades.checkIfUserIsAuthorized(data, status, xhr);

                    viewControllerNS.setKey(params.field_name, data);

                    viewControllerNS.applyFieldPermissions(true, field, data, function() {
                        if (callback) {
                            callback();
                        }
                    });

                })
                .fail(function (xhr, status, error) {
                    Hades.showError(error, xhr.responseText, xhr, status, error);

                    viewControllerNS.applyFieldPermissions(false, field);
                });
        } else {
            viewControllerNS.applyFieldPermissions(true, field, viewControllerNS[params.field_name], function() {
                if (callback) {
                    callback();
                }
            });
        }

    },
    setKey: function (keyType, message) {

        viewControllerNS[keyType] = message;

    },
    checkGridColumnPermissions: function(column, callback, colSize, colIndex){
        //Hades.showLoading();

        //debug.log('checkGridColumnPermissions', column, callback, colSize, colIndex);

        var params = {
            field_name: column.name
        };

        //debug.log('viewControllerNS.checkFieldPermissions', params, field);

        if (column.permission_col  || colSize == colIndex){

            $.getJSON('/permission/get_field_permission_details', params)
                .done(function (data, status, xhr) {
                    Hades.checkIfUserIsAuthorized(data, status, xhr);

                    viewControllerNS.applyGridColumnPermissions(true, column, data, callback, colSize, colIndex);

                })
                .fail(function (xhr, status, error) {
                    Hades.showError(error, xhr.responseText, xhr, status, error);
                    //Hades.hideLoading();

                    viewControllerNS.applyGridColumnPermissions(false, column, null, callback, colSize, colIndex);
                });
        }else{
            viewControllerNS.applyGridColumnPermissions(false, column, null, callback, colSize, colIndex);
        }
    },
    applyGridColumnPermissions: function(success, col, permission_details, callback, colSize, colIndex){
        if(success){
            if (permission_details && permission_details.read === 'f'){
                col.hidden = true;
            }
        } else{

        }

        if(colSize == colIndex){
            callback();
        }
    },
    applyFieldPermissions: function(success, field, permission_details, callback){
        //debug.log('applyFieldPermissions', success, $(field).data('permission_field_name'), permission_details); //, permission_details.mandatory === 'f', permission_details.read === 'f', permission_details.write === 'f');


        if(success && permission_details){
            var field_name = $(field).data('permission_field_name');

            if (permission_details.mandatory == false){
                //Remove Mandatory
                $(field).removeClass('form_field_mandatory');
                $(field).closest('.form_elem').removeClass('form_label_mandatory');
                $(field).closest('.form_elem').find('label[for='+$('#np_patient_fiscal_number').prop('name')+']').removeClass('form_label_mandatory');

                $('[data-permission_field_related='+ field_name + ']').removeClass('form_field_mandatory');

            } else //if (permission_details.mandatory === 't')
            {
                //debug.log("permission_field_name",field_name);
                if (!(($('#np_patient_temporary_yes').is(':checked')) && (field_name == 'permission_field_patient_doc_number'|| field_name == 'permission_field_patient_contact'|| field_name == 'permission_field_patient_fiscal_number'|| field_name == 'permission_field_patient_nnu' || field_name == 'permission_field_patient_birth_date'))) {

                    if (!(($('#np_patient_temporary_no').is(':checked') && $('#np_patient_resident_no').is(':checked')) && (field_name == 'permission_field_patient_fiscal_number'|| field_name == 'permission_field_patient_nnu'))) {

                        //Add mandatory
                        $(field).addClass('form_field_mandatory');
                        $(field).closest('.form_elem').addClass('form_label_mandatory');
                        $(field).closest('.form_elem').find('label[for=' + $('#np_patient_fiscal_number').prop('name') + ']').addClass('form_label_mandatory');
                        $('[data-permission_field_related=' + field_name + ']').addClass('form_field_mandatory');
                    }

                }
            }

            if (permission_details.write == false){
                //Make ReadOnly
                $(field).attr('disabled', 'disabled');

                //Remove Mandatory
                $(field).removeClass('form_field_mandatory');
                $('[data-permission_field_related='+ field_name + ']').removeClass('form_field_mandatory');
                $('[data-permission_field_related='+ field_name + ']').attr('disabled', 'disabled');
            }

            if (permission_details.read == false){
                //Hide
                $(field).hide();

                $('[data-permission_field_ct='+ field_name + ']').hide();

                //$('[data-permission_field_masked='+ field_name + ']').show();

                $(field).closest('div:not("[data-permission_field_name='+ field_name + ']")').append('<div class="float_left" data-permission_field_masked="'+ field_name + '"><span>---</span></div>');

                //Remove Mandatory
                $(field).removeClass('form_field_mandatory');
                $('[data-permission_field_related='+ field_name + ']').removeClass('form_field_mandatory');
            }
        } else{
            debug.log('applyFieldPermissions: UnexpectedError', success, $(field).data('permission_field_name'), permission_details);
            //Unexpected error, exception not implemented
        }

        callback();

       // Hades.hideLoading();
    },

/************************************************************
* OVERBOOKING
 ************************************************************/
    checkOverbooking: function(allow_overbooking, params, callback){

        Hades.showLoading();

        //debug.log('allow_overbooking', allow_overbooking);

        if (allow_overbooking.toLowerCase() === 'true'){

            if (params.show_overbooking_outofcalendar_alert == 'true'){
                var tempSpecList = params.specList;
                var tempProfList = params.profList;
                params.specList = {};
                params.profList = {};
                var cell;

                if (params.elem){
                    cell = params.elem;
                    params.elem = null;
                }

                $.getJSON('/appointments/verify_if_appointment_exists', params)
                    .done(function (data, status, xhr) {
                        Hades.checkIfUserIsAuthorized(data, status, xhr);

                        params.specList = tempSpecList;
                        params.profList = tempProfList;

                        params.elem = cell;
                        params.app_num = data;
                        callback(0, params);

                    })
                    .fail(function (xhr, status, error) {
                        Hades.showError(error, xhr.responseText, xhr, status, error);
                    });

            } else {
                callback(0, params);
            }

        }else{

            var tempSpecList = params.specList;
            var tempProfList = params.profList;
            params.specList = {};
            params.profList = {};
            var cell;

            if (params.elem){
                cell = params.elem;
                params.elem = null;
            }

            $.getJSON('/appointments/verify_if_appointment_exists', params)
                .done(function (data, status, xhr) {
                    Hades.checkIfUserIsAuthorized(data, status, xhr);

                    params.specList = tempSpecList;
                    params.profList = tempProfList;

                    params.elem = cell;
                    callback(data, params);

                })
                .fail(function (xhr, status, error) {
                    Hades.showError(error, xhr.responseText, xhr, status, error);
                });

        }

    },
/******************************
 * CHECK PERIOD RESTRICTIONS
*******************************/

    checkPeriodRestrictions: function(overbooking, params, callback, callbackContext){
        Hades.showLoading();

        var tempSpecList = params.specList;
        var tempProfList = params.profList;
        params.specList = {};
        params.profList = {};
        var cell;

        if (params.elem){
            cell = params.elem;
            params.elem = null;
        }

        $.getJSON('/configurations/calendar/check_period_restrictions', params)
           .done(function (data, status, xhr) {
              Hades.checkIfUserIsAuthorized(data, status, xhr);

               params.specList = tempSpecList;
               params.profList = tempProfList;

               params.elem = cell;
                if (data.result.allow_schedule === 't' || data.result.allow_schedule == 'true' || data.result.allow_schedule){
                    if (callbackContext === 'singleParams'){
                        callback(params);
                    }else{

                        callback.checkPeriodRestriction(overbooking, params, callback.checkOverbooking);
                    }
                }
                else{
                    bootbox.alert(GlobalTranslations['APP_LABEL.2777']);
                }

            })
            .fail(function (xhr, status, error) {
               Hades.showError(error, xhr.responseText, xhr, status, error);
            });

/*
        if (callbackContext && callbackContext === 'singleParams'){
            callback(params);
        }else{

            callback.checkPeriodRestriction(overbooking, params, callback.checkOverbooking);
        }
*/
    }
};